import enums from '../enums/RdsLife.enums';
import calendarUtil from '../services/Calendar.util';
import CalendarEvent from '../models/calendarEvent.model';
import gapiWrapper from '../services/GapiWrapper.service';
import RestStore from '../stores/RestStore';
import config from '../config';
const restStore = new RestStore();
// const gapi = window.gapi;

class CalendarService {
  _events = [];
  dataLoaded = false;
  constructor(displayMode, displayDay) {
    this._displayMode = displayMode;
    this.displayDay = new Date(displayDay);
  }
  init(events, displayDay) {
    this._events = events;
    this._alreadyRendered = [];
    this.updating = false;
    this.monthName = '';
    if (!!!displayDay) {
      displayDay = this.displayDay;
    } else {
      displayDay = Number(displayDay);
    }
    this.displayDay = new Date(displayDay);
    this.dataLoaded = true;
  }
  get displayMode() {
    return this._displayMode;
  }
  set displayMode(displayMode) {
    console.log('displayMode', displayMode);

    this._displayMode = displayMode;
    try {
      if (displayMode === enums.calendarViewModes.WEEK) {
        this.displayEvents = this.displayMonth.events || [];
      }
      if (displayMode === enums.calendarViewModes.MONTH) {
        this.displayEvents = this.displayMonth.events || [];
      }
    } catch (error) {
      console.warn(error);
      this.displayEvents = [];
    }
  }
  get displayDay() {
    return this._displayDay;
  }
  set displayDay(displayDay) {
    const PREV_EVENTS = this.displayEvents;
    this._displayDay = displayDay;
    // if (this.displayMode === enums.calendarViewModes.WEEK && this._events.length) {
    this.displayWeek = calendarUtil.getWeekFromDate(displayDay, this._events);
    this.displayMonth = calendarUtil.getMonthFromDate(displayDay, this._events);
    this.displayEvents = this.displayWeek.events;
    if (this.displayMode === enums.calendarViewModes.MONTH) {
      this.displayEvents = this.displayMonth.events;
    }
    if (!this.displayEvents.length) {
      this.displayEvents = PREV_EVENTS;
    }
    this.monthName = this._getMonthName();
    this.year = this.displayWeek.startDay.getFullYear();
    // }
  }

  get events() {
    return this._events;
  }
  set events(events) {
    this._events = events;
  }
  showNextWeek() {
    this.updating = true;
    // console.log(this.updating);

    let displayDay = new Date(this.displayDay);
    displayDay.setDate(displayDay.getDate() + 7);
    this.displayDay = displayDay;
    setTimeout(() => { this.updating = false; console.log(this.updating); console.log(this); }, 100);
  }
  showPrevWeek() {
    this.updating = true;
    // console.log(this.updating);
    let displayDay = new Date(this.displayDay);
    displayDay.setDate(displayDay.getDate() - 7);
    this.displayDay = displayDay;
    setTimeout(() => { this.updating = false; console.log(this.updating); console.log(this); }, 100);
  }
  showNextMonth() {
    this.updating = true;
    // console.log(this.updating);

    let displayDay = new Date(this.displayDay);
    displayDay.setMonth(displayDay.getMonth() + 1);
    this.displayDay = displayDay;
    setTimeout(() => { this.updating = false; console.log(this.updating); console.log(this); }, 100);
  }
  showPrevMonth() {
    this.updating = true;
    // console.log(this.updating);
    let displayDay = new Date(this.displayDay);
    displayDay.setMonth(displayDay.getMonth() - 1);
    this.displayDay = displayDay;
    setTimeout(() => { this.updating = false; console.log(this.updating); console.log(this); }, 100);
  }

  _getMonthName() {
    const startMonth = calendarUtil.getMonthNameFromDate(this.displayWeek.startDay);
    if (this.displayMode === enums.calendarViewModes.WEEK) {
      const endMonth = calendarUtil.getMonthNameFromDate(this.displayWeek.endDay);
      if (startMonth !== endMonth) {
        return startMonth + ' / ' + endMonth;
      }
    }
    return startMonth;
  }
  getGCalendarEvents(users) {
    if (gapiWrapper.androidLogin) {
      return this.getAndroidGCalendarEvents(users);
    }
    return new Promise((resolve, reject) => {
      const calendarId = config.calendarId;
      gapiWrapper.getGapiClient().then((gapiClient) => {
        gapiClient.calendar.events.list({
          calendarId: calendarId,
          timeMin: (new Date()).toISOString(),
          timeZone: 'Europe/Rome',
          showDeleted: false,
          singleEvents: true,
          maxResults: 10,
          orderBy: 'startTime'
        }).then(function (response) {
          let calendarEvents = [];
          let events = response.result.items;
          for (let i = 0; i < events.length; i++) {
            const element = events[i];
            const dateStart = !!element.start.date ? new Date(element.start.date) : new Date(element.start.dateTime);
            const dateEnd = !!element.start.date ? new Date(element.end.date) : new Date(element.end.dateTime);
            if (!!element.start.date) {
              dateEnd.setDate(dateEnd.getDate() - 1);
            }
            calendarEvents.push(new CalendarEvent({
              id: element.iCalUID,
              name: element.summary,
              dateStart: dateStart.getTime(),
              dateEnd: dateEnd.getTime(),
              icon: '',
              liked: false,
              description: element.description,
              color: element.colorId,
              location: element.location,
              users: users
            }));
          }
          resolve(calendarEvents);
        });
      });
    });
  }

  getAndroidGCalendarEvents(users) {
    return new Promise((resolve, reject) => {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      headers.append('Authorization', 'Bearer ' + gapiWrapper.token);
      const calendarId = config.calendarId;
      const url = `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events`;
      const fetchConfig = {
        method: 'GET',
        headers: headers,
        mode: 'cors',
        cache: 'default'
      };
      return restStore.sendRequest(url, fetchConfig)
        .then(
          response => response.json()
        )
        .then(function (response) {
          let calendarEvents = [];
          let events = response.items;
          for (let i = 0; i < events.length; i++) {
            const element = events[i];
            const dateStart = !!element.start.date ? new Date(element.start.date) : new Date(element.start.dateTime);
            const dateEnd = !!element.start.date ? new Date(element.end.date) : new Date(element.end.dateTime);
            if (!!element.start.date) {
              dateEnd.setDate(dateEnd.getDate() - 1);
            }
            calendarEvents.push(new CalendarEvent({
              id: element.iCalUID,
              name: element.summary,
              dateStart: dateStart.getTime(),
              dateEnd: dateEnd.getTime(),
              icon: '',
              liked: false,
              description: element.description,
              color: element.colorId,
              location: element.location,
              users: users
            }));
          }
          resolve(calendarEvents);
        })
        .catch(e => console.warn(e));
    });
  }
}
export default new CalendarService(enums.calendarViewModes.WEEK, new Date());
